var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"flex flex-row select-none",class:{
    'mb-4': !_vm.compact,
    'cursor-pointer hover:text-blue-800': !_vm.disabled,
    'cursor-not-allowed opacity-50': _vm.disabled
  },on:{"click":function($event){$event.preventDefault();return _vm.toggleChecked.apply(null, arguments)}}},[_c('a',{staticClass:"w-8 h-6 text-xl -mt-1"},[_c('icon',{attrs:{"face":_vm.wIcon}})],1),_c('p',{staticClass:"mt-px pt-px text-sm"},[_vm._v(" "+_vm._s(_vm.wLabel)+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }